import {
  INTERNAL_PROJECTS_LIST_LOADING,
  INTERNAL_PROJECTS_LIST_SUCCESS,
  INTERNAL_PROJECTS_LIST_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { listItemsService } from "services/listItemsService";
import { internalProjectsUrl } from "api/apiUrls";

export const internalProjectsActions = () => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: INTERNAL_PROJECTS_LIST_LOADING, payload: true });
    const response = await listItemsService(
      `${internalProjectsUrl}`,
      "donation=Charity Projects"
    );

    dispatch({ type: INTERNAL_PROJECTS_LIST_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: INTERNAL_PROJECTS_LIST_FAILURE, payload: err });
  } finally {
    dispatch({ type: INTERNAL_PROJECTS_LIST_LOADING, payload: false });
  }
};
